export default "__VITE_ASSET__lzYJ_32k__"